import { useState } from "react";
import SearchService from "../service/SearchService";
import { useHistory, useLocation } from "react-router-dom";

const useConfirmSearch = ({ productId, onError }) => {
  const [loadingConfirmSearch, setLoadingConfirmSearch] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const searchService = new SearchService();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const confirmSearch = async () => {
    try {
      setLoadingConfirmSearch(true);

      if (localStorage.getItem("__extraconomy_search") && !isFringeBenefitsPage) {
        const searchObj = JSON.parse(localStorage.getItem("__extraconomy_search"));

        const res = await searchService.postConfirmSearch(searchObj.id, productId);

        if (res.messageCode !== 200000) {
          onError(res.messageCode);
          if (res.messageCode === 500000) console.log(res);
          setLoadingConfirmSearch(false);
        } else localStorage.removeItem("__extraconomy_search");
      }

      if (isFringeBenefitsPage) {
        history.push(`/fringe-benefit/${productId}`);
        return;
      }

      // window.location.href = `/product?id=${productId}`;
      history.push(`/product/${productId}`);
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        history.push("/login");
      }
      console.log(e);
    }
  };

  return {
    loadingConfirmSearch,
    confirmSearch,
  };
};

export default useConfirmSearch;
